import { Environment } from './environment.model';
import { VERSION, CLIENT_STAGING, FIREBASE_STAGING, AI_URL_STAGING, BACKEND_STAGING, PAYMENT_PROV_STAGING, GOOGLE_API_STAGING, RC, LOG_LEVEL_STAGING, PAY_URL_STAGING, ZEUS_STAGING, GOOGLE_CLIENT_ID_STAGING, FACEBOOK_CLIENT_ID_STAGING, LINKEDIN_CLIENT_ID_STAGING } from './global';

export const ENV: Environment = {
  version: `${VERSION}-ST${RC ? '-rc.' + RC : ''}`,
  mode: 'Staging',
  production: true,
  client: CLIENT_STAGING,
  firebase: FIREBASE_STAGING,
  payment_provider: PAYMENT_PROV_STAGING,
  pay_api_url: PAY_URL_STAGING,
  ia_api_url: AI_URL_STAGING,
  backend: BACKEND_STAGING,
  zeus: ZEUS_STAGING,
  log_level: LOG_LEVEL_STAGING,
  google_api: GOOGLE_API_STAGING,
  google_client_id: GOOGLE_CLIENT_ID_STAGING,
  facebook_client_id: FACEBOOK_CLIENT_ID_STAGING,
  linkedin_client_id: LINKEDIN_CLIENT_ID_STAGING
}


// WEBPACK FOOTER //
// ./src/environments/environment.staging.ts